import React, {Fragment, PureComponent} from "react"

import tracking from "@irati-tracking/recognition/recognition"
import Button from "@irati/ui/src/Button"
import {injectIntl, FormattedMessage} from "@irati/utils/lang"

import CreateRecognition from "../Popup/CreateRecognition"

interface Props {
  large: boolean
}

class RecogniseButton extends PureComponent<Props> {
  handleFocus = () => {
    tracking.startCreateRecognition()
    this.createPopup.show()
  }

  render() {
    const {large} = this.props

    return (
      <Fragment>
        <Button primary large={large} onClick={this.handleFocus}>
          <FormattedMessage id="recognition.banner.button" />
        </Button>
        <CreateRecognition ref={(c) => { this.createPopup = c }} />
      </Fragment>
    )
  }
}

export default injectIntl(RecogniseButton)
